import { media } from '@/styles/responsive';
import styled from 'styled-components';

export const Facts = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;

  ${media.tablet`
    grid-template-columns: repeat(2, minmax(0, 1fr));
  `}
`;
